import {createReducer, on} from '@ngrx/store';
import {INITIAL_LOAD_STATUS_SUBSTATE, LoadStatusSubstate} from '@store/store.types';
import {FAILED, LOADED, LOADING} from '@store/common/common.types';
import {AccountActions} from './account.actions';
import {PatronBalanceTransaction, SquareAppDetails} from './account.types';
import {FALLBACK_SQUARE_APP_DETAILS} from '@store/account/account.fallback';

export interface AccountState {
  balanceTransactions: LoadStatusSubstate & {
    data: PatronBalanceTransaction[];
    includeAllTransactions: boolean;
  };
  squareAppDetails: LoadStatusSubstate & {
    data: SquareAppDetails
  };
}

export const INITIAL_ACCOUNT_STATE: AccountState = {
  balanceTransactions: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
    includeAllTransactions: false
  },
  squareAppDetails: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: FALLBACK_SQUARE_APP_DETAILS,
  }
};

export const accountState = createReducer(
  INITIAL_ACCOUNT_STATE,

  on(AccountActions.loadBalanceTransactions, state => ({
    ...state,
    balanceTransactions: {
      ...state.balanceTransactions,
      loadStatus: LOADING
    }
  })),
  on(AccountActions.loadBalanceTransactionsSuccess, (state, {listData: {data}}) => ({
    ...state,
    balanceTransactions: {
      ...state.balanceTransactions,
      loadStatus: LOADED,
      data,
    }
  })),
  on(AccountActions.loadBalanceTransactionsFailure, state => ({
    ...state,
    balanceTransactions: {
      ...INITIAL_ACCOUNT_STATE.balanceTransactions,
      loadStatus: FAILED
    }
  })),
  on(AccountActions.toggleIncludeAllBalanceTransactions, state => ({
    ...state,
    balanceTransactions: {
      ...state.balanceTransactions,
      includeAllTransactions: !state.balanceTransactions.includeAllTransactions
    }
  })),
  on(AccountActions.loadSquareAppDetails, state => ({
    ...state,
    squareAppDetails: {
      ...state.squareAppDetails,
      loadStatus: LOADING
    }
  })),
  on(AccountActions.loadSquareAppDetailsSuccess, (state, {squareAppDetails}) => ({
    ...state,
    squareAppDetails: {
      ...state.squareAppDetails,
      loadStatus: LOADED,
      data: squareAppDetails,
    }
  })),
  on(AccountActions.loadSquareAppDetailsFailure, state => ({
    ...state,
    squareAppDetails: {
      ...INITIAL_ACCOUNT_STATE.squareAppDetails,
      loadStatus: FAILED
    }
  })),
);
